/**
 * ContactClientServices component module.
 * @module shared/components/ContactClientServices
 *
 */
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {DescriptiveText, LinkedText} from '../../index';
import {formatter} from '../../utils/utils';

const ContactClientServices = props => {
  const {alignment, product} = props;
  const {brand} = product;
  return <DescriptiveText alignment={alignment} preset={'paragraph'}>
    <DescriptiveText margin={props.helpTextMargin}>For help, contact Client Services:</DescriptiveText><br/>
    Email: <LinkedText href={`mailto: ${brand.clientServicesEmail}`}
                       size='lg'>{brand.clientServicesEmail}</LinkedText><br/>
    Phone: <LinkedText href={`tel:${brand.clientServicesPhone}`}
                       size='lg'>{formatter('phone')(brand.clientServicesPhone)}</LinkedText>
  </DescriptiveText>;
};

const mapStateToProps = state => ({
  product: state.product,
});

export default connect(mapStateToProps, null)(ContactClientServices);

ContactClientServices.propTypes = {
  /**
   * The margin of help text.
   */
  helpTextMargin: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'right', 'center']),
  product: PropTypes.shape({
    brand: PropTypes.object.isRequired,
  }).isRequired,
};
